function cov_2cvbicv750() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowUp.tsx";
  var hash = "a7c86bde9a1e8042806c36efd86bbc5760244093";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ArrowUp.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a7c86bde9a1e8042806c36efd86bbc5760244093"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2cvbicv750 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2cvbicv750();
var Icon = (cov_2cvbicv750().s[0]++, {
  name: 'arrow-up',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.8839 12.8839C20.372 12.3957 20.372 11.6043 19.8839 11.1161L12.8839 4.11612C12.3957 3.62796 11.6043 3.62796 11.1161 4.11612L4.11612 11.1161C3.62796 11.6043 3.62796 12.3957 4.11612 12.8839C4.60427 13.372 5.39573 13.372 5.88388 12.8839L10.75 8.01777V19C10.75 19.6904 11.3096 20.25 12 20.25C12.6904 20.25 13.25 19.6904 13.25 19V8.01777L18.1161 12.8839C18.6043 13.372 19.3957 13.372 19.8839 12.8839Z\" fill=\"currentColor\"/>"
});
export default Icon;